const LIGHTHOUSE_TEMPLATE_PATH = '/lighthouse/standalone-template.html';
const LIGHTHOUSE_SCRIPT_PATH = '/lighthouse/standalone.js';

let assetsPromise = null;

const sanitizeJson = (object) => {
  return JSON.stringify(object)
    .replace(/</g, '\\u003c')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
};

const replaceStrings = (source, replacements) => {
  if (replacements.length === 0) {
    return source;
  }

  const [firstReplacement, ...rest] = replacements;

  return source
    .split(firstReplacement.search)
    .map((part) => replaceStrings(part, rest))
    .join(firstReplacement.replacement);
};

const loadAssets = async () => {
  if (!assetsPromise) {
    assetsPromise = Promise.all([
      fetch(LIGHTHOUSE_TEMPLATE_PATH).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch Lighthouse template: ${response.status}`);
        }
        return response.text();
      }),
      fetch(LIGHTHOUSE_SCRIPT_PATH).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch Lighthouse script: ${response.status}`);
        }
        return response.text();
      })
    ]).then(([template, script]) => ({
      template,
      script,
    }));
  }

  return assetsPromise;
};

export const generateLighthouseReportHtml = async (lighthouseResult) => {
  const { template, script } = await loadAssets();
  const sanitizedJson = sanitizeJson(lighthouseResult);
  const sanitizedJavascript = script.replace(/<\//g, '\\u003c/');

  return replaceStrings(template, [
    { search: '%%LIGHTHOUSE_JSON%%', replacement: sanitizedJson },
    { search: '%%LIGHTHOUSE_JAVASCRIPT%%', replacement: sanitizedJavascript },
  ]);
};


